export function SubscriptionWidgetApp(product, initialSelectedVariantId, formatMoney) {
  return {
    pubSubEvent: null,
    selectedVariantId: initialSelectedVariantId,
    selectedSellingPlanGroupId: null,
    isAddingToCart: false,
    get selectedVariant() {
      if (!this.selectedVariantId) return null;

      return product.variants.find((variant) => variant.id === this.selectedVariantId);
    },
    get subscriptionData() {
      if (!this.selectedVariant) return null;

      return this.selectedVariant.metafields.custom.wipes_subscription_mapping.find(
        (entry) => entry.country_iso_code.toLowerCase() === window.Shopify.country.toLowerCase()
      );
    },
    get bundleProduct() {
      if (!this.subscriptionData) return null;

      return this.subscriptionData.bundle_product;
    },
    get subscriptionProduct() {
      if (!this.subscriptionData) return null;

      return this.subscriptionData.ws_product;
    },
    get variantHasSubscription() {
      if (!this.selectedVariant) return false;

      return !!this.selectedVariant.metafields.custom.wipes_subscription_mapping.length > 0;
    },
    get selectedSellingPlan() {
      if (!this.subscriptionProduct || !this.selectedSellingPlanGroupId) return false;

      console.log(
        this.subscriptionProduct.selling_plan_groups.find(
          (sellingPlanGroup) => sellingPlanGroup.id === this.selectedSellingPlanGroupId
        )
      );

      return this.subscriptionProduct.selling_plan_groups.find(
        (sellingPlanGroup) => sellingPlanGroup.id === this.selectedSellingPlanGroupId
      ).selling_plans[0];
    },
    async addBundleToCart() {
      const bundle = {
        externalProductId: String(this.bundleProduct.id), // Bundle's Shopify Product ID
        externalVariantId: String(this.bundleProduct.variant_id), // Bundle's Shopify Variant ID
        selections: [
          {
            collectionId: this.subscriptionData.collection_id, // Shopify Collection 1
            externalProductId: String(this.subscriptionProduct.id), // Shopify Product ID 1
            externalVariantId: String(this.subscriptionProduct.variant_id), // Shopify Variant ID 1
            quantity: 15,
            sellingPlan: this.selectedSellingPlan.id, // Child Product Selling Plan ID 1
          },
        ],
      };

      this.isAddingToCart = true;

      const cartItems = await window.recharge.bundle.getDynamicBundleItems(
        bundle,
        this.bundleProduct.handle
      );
      const cartData = {items: cartItems};

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(cartData),
        });

        if (!response.ok) throw new Error('Error while adding bundle to cart');

        const result = await response.json();
        console.log(result);

        window.location.href = '/cart/checkout';
      } catch (error) {
        console.error(error.message);
      } finally {
        this.isAddingToCart = false;
      }
    },
    computeWipesPerDay(interval) {
      // 15: pack of wipes
      // 60: number of wipes in a pack
      // 30: number of days in a month
      return Math.ceil((15 * 60) / (interval * 30));
    },
    formattedMoney(money) {
      const {country, language, currency} = window.ShopifyLocalization;

      return new Intl.NumberFormat(`${language}-${country}`, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(money);
    },
    preselectFavoriteSellingPlanGroup() {
      if (!this.subscriptionProduct?.selling_plan_groups?.length) return;

      this.selectedSellingPlanGroupId = this.subscriptionProduct.selling_plan_groups[2].id;
    },
    subscriptionWidgetMounted() {
      console.log(product);
      this.pubSubEvent = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        this.selectedVariantId = payload.data.variant.id;

        this.preselectFavoriteSellingPlanGroup();
      });

      this.preselectFavoriteSellingPlanGroup();
    },
    subscriptionWidgetUnmounted() {
      this.pubSubEvent = null;
    },
    $delimiters: ['${', '}$'],
  };
}
